module.exports = true;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_library.js
 ** module id = 954
 ** module chunks = 1
 **/